import { Plugin } from './Plugin';
import { GlobalsPlugin } from './GlobalsPlugin';
import { RotatePlugin } from './RotatePlugin';
import { MovePlugin } from './MovePlugin';
import { SSAARenderPass } from 'three/examples/jsm/postprocessing/SSAARenderPass.js';
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';

export class SSAAPlugin extends Plugin{
	constructor(manager){
		super(manager);

		this.dependencies.add(RotatePlugin);
		this.dependencies.add(MovePlugin);
		this.dependencies.add(GlobalsPlugin);

		this.viewer.rendering.disableRenderPass = true;
		this.ssaa = new SSAARenderPass(this.viewer.rendering.scene, this.viewer.rendering.camera);
		this.ssaa.unbiased = true;
		this.ssaa.sampleLevel = 1;
		this.viewer.rendering.customPasses.add(this.ssaa);

		// this.gammaPass = new ShaderPass( GammaCorrectionShader );
		// this.viewer.rendering.customPasses.add(this.gammaPass);
	}

	update(){
		this.manager.get(GlobalsPlugin).antialias = false;
	}
}